
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { QueryResult } from 'src/app/reports/models/query/query-result.model';
import { RteDialogRef } from 'rte-library';
import { MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-query-result-dialog',
  templateUrl: './query-result-dialog.component.html',
  styleUrls: ['./query-result-dialog.component.scss']
})
export class QueryResultDialogComponent implements OnInit {

  displayedColumns: Array<string> = new Array<string>();

  constructor(
    public dialogRef: RteDialogRef<QueryResultDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public queryResult: QueryResult) {
  }

  ngOnInit() {
    if (this.queryResult != null) {
      const columns = this.queryResult.Columns;

      columns.forEach((value) => {
        if (this.displayedColumns.indexOf(value.Name) === -1) {
          this.displayedColumns.push(value.Name);
        }
      });
    }
  }
}
